import React from "react"
import styled from "styled-components"
import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"
import breakpoints from "../../../styles/breakpoints"
import { Link } from "gatsby"

const Title = styled.h2`
  ${fonts.helveticaNeueCondensedBold};
  color: #1D1D1D;
  letter-spacing: 0;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.4px;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid ${colors.newBorderGrey};
  text-transform: uppercase;
  text-align: center;
  
  @media(min-width: ${breakpoints.lg}){
    text-align: left;
  }
`;

const Text = styled.div`
  ${fonts.helveticaNeueLight};
  color: #1D1D1D;
  letter-spacing: 0;
  color: ${colors.black};
  font-size: 12px;
  line-height: 21px;
  text-align: center;

  a {
    color: ${colors.black};
  }
  
  @media(min-width: ${breakpoints.lg}){
    text-align: left;
  }
`;

const Card = styled.div`
  position: relative;
  max-width: 276px;
  margin: auto;
  
  @media(min-width: ${breakpoints.lg}){
    margin-left: ${props => props.$isFirst ? '0' : '48px'};
    max-width: 266px;
  }
`;

const CardContainer = styled.div`
`;

const Details = styled.div`	
`;

const DetailCard = (props) => {
  const { isFirst } = props
  return (
    <CardContainer $isFirst={isFirst ? 1 : 0}>
      <Card $isFirst={isFirst ? 1 : 0}>
        <Details>
          <Title>{props.detail.title}</Title>
          {props.detail.email ?
            <Text>
              {props.detail.text}&nbsp;
              {props.detail.linkLabel != null &&
              <Link to={props.detail.linkUrl}>{props.detail.linkLabel}</Link>
              }
              <a href={`mailto:${props.detail.email}`}>{props.detail.email}</a>.
            </Text>
            :
            <Text>
              {props.detail.text}&nbsp;
              {props.detail.linkLabel != null &&
              <Link to={props.detail.linkUrl}>{props.detail.linkLabel}</Link>
              }
            </Text>
          }
        </Details>
      </Card>
    </CardContainer>
  )
};

export default DetailCard
